import { Actions } from "../Actions";
import { RouteFragment } from "../../Routing/RouteFragment";
import { NavigationActionType } from "./NavigationActionType";
import { NavigationDispatcher } from "../Variables";

export class NavigationActionsStatic extends Actions {
    public enter(url: RouteFragment): void {
        NavigationDispatcher.dispatch({ actionType: NavigationActionType.Enter, url });
    }
}
